import React from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useQuery } from '@tanstack/react-query';
import { Container, Grid, Card, Input, Segment, Header, Icon, Label, Statistic } from 'semantic-ui-react';
import { profiles } from '../services/api';

function Profiles() {
  const [search, setSearch] = useState('');
  
  const { data: profilesList, isLoading } = useQuery({
    queryKey: ['profiles', search],
    queryFn: () => profiles.list({ search }),
  });

  return (
    <>
      <Helmet>
        <title>Soapee - Profiles</title>
      </Helmet>

      <Container>
        <Segment vertical>
          <Grid>
            <Grid.Row>
              <Grid.Column width={16}>
                <Header as="h1">Profiles</Header>
                <Input
                  icon="search"
                  placeholder="Search profiles..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  fluid
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={16}>
                {isLoading ? (
                  <Segment loading />
                ) : (
                  <Card.Group>
                    {profilesList?.data?.map((profile) => (
                      <Card key={profile.id}>
                        <Card.Content>
                          <Card.Header>
                            <Icon name="user circle" size="large" />
                            {profile.name}
                          </Card.Header>
                          <Card.Meta>
                            Member since {new Date(profile.created_at).toLocaleDateString()}
                          </Card.Meta>
                          <Card.Description>
                            {profile.bio}
                          </Card.Description>
                        </Card.Content>
                        <Card.Content extra>
                          <Grid columns={3} divided>
                            <Grid.Row>
                              <Grid.Column>
                                <Statistic size="tiny">
                                  <Statistic.Value>{profile.recipe_count}</Statistic.Value>
                                  <Statistic.Label>Recipes</Statistic.Label>
                                </Statistic>
                              </Grid.Column>
                              <Grid.Column>
                                <Statistic size="tiny">
                                  <Statistic.Value>{profile.post_count}</Statistic.Value>
                                  <Statistic.Label>Posts</Statistic.Label>
                                </Statistic>
                              </Grid.Column>
                              <Grid.Column>
                                <Statistic size="tiny">
                                  <Statistic.Value>{profile.comment_count}</Statistic.Value>
                                  <Statistic.Label>Comments</Statistic.Label>
                                </Statistic>
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </Card.Content>
                      </Card>
                    ))}
                  </Card.Group>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Container>
    </>
  );
}

export default Profiles; 